module.exports = __webpack_public_path__ + "static/media/cross.e5e62321.svg";